import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class SponsoredProductsBlock extends PureComponent {
  render() {
    const {
      activeView,
      productsGridRow,
      productsListRow
    } = this.props;

    return (
      <div className={`sponsored-products-block ${activeView === 'grid' ? 'grid' : 'list'}`}>
        <div>
          <div className="sponsored-products-label">{this.props.sponsoredProductsLabel}</div>
          {activeView === 'grid' &&
            <div className="sponsored-products__grid-wrapper">
              {productsGridRow}
            </div>
          }
          {activeView === 'list' && productsListRow}
        </div>
      </div>
    );
  }
}

SponsoredProductsBlock.displayName = 'SponsoredProductsBlock';

SponsoredProductsBlock.propTypes = {
  productsGridRow: PropTypes.node.isRequired,
  productsListRow: PropTypes.node.isRequired,
  sponsoredProductsLabel: PropTypes.string,
  activeView: PropTypes.string
};

SponsoredProductsBlock.defaultProps = {
  sponsoredProductsLabel: 'Sponsored products',
  activeView: 'grid'
};

export default SponsoredProductsBlock;
